module.exports = __webpack_public_path__ + "img/index_bg.ea4b53b3.png";